export default function useAuth() {
  // @ts-ignore
  const token = localStorage.getItem("access_token");
  const authed = !!token;

  return { authed } ;
}
